export default __webpack_public_path__ + "static/media/dots_active.5fe4f74a.svg";